<template>
  <div class="page-content-wrapper user-list-page"  v-check-permission="'list-roles'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <h4 class="mt-0 header-title">Roles</h4>
              <p class="text-muted m-b-30 font-14">Desde aqui podras administrar los roles.</p>

              <div class="table-rep-plugin">
                <div class="btn-toolbar">
                  <div class="btn-group dropdown-btn-group pull-right">
                    <router-link to="/edit-role" v-check-permission="'edit-roles'" class="btn btn-primary waves-effect waves-light">Agregar nuevo</router-link>
                  </div>
                  <div class="clearfix"></div>
                </div>

                <div class="table-responsive b-0" data-pattern="priority-columns">

                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th>Rol</th>
                      <th>Estado</th>
                      <th>Creado el</th>
                      <th class="col-icon" v-check-permission="'edit-roles'"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="role in roles" :key="role._id">
                      <td>{{ role.name }}</td>
                      <td><span class="badge badge-success" v-if="role.active">Activo</span><span class="badge badge-primary" v-if="!role.active">Inactivo</span> <span class="badge badge-info" v-if="role.isDefault">Predeterminado</span> </td>
                      <td>{{ role.createdAt | moment("DD/MM/YYYY") }}</td>
                      <td v-check-permission="'edit-roles'">
                        <router-link :to="{ name: 'edit-role', params: { id: role._id }}" class="text-info mr-3"><i class="fa fa-pencil"></i></router-link>
                        <a href="javascript:void(0);" class="text-primary" @click="setRole(role)" data-toggle="modal" data-target="#deleteConfirm"><i class="fa fa-minus-circle"></i></a>
                      </td>
                    </tr>
                    <tr v-if="roles.length === 0">
                      <td colspan="4">Aun no se han cargado roles.</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- end col -->
      </div> <!-- end row -->

    </div><!-- container -->

    <div id="deleteConfirm" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title mt-0">Confirmar eliminación</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>¿Realmente desea eliminar el registro?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary delete-btn" @click="deleteRole(role._id)">Confirmar</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

  </div>
</template>


<script>
  export default {
    name: 'role-list',


    created () {
      this.getAllRoles()
    },


    data () {
      return {

      }
    },


    computed: {

      roles: function () {
        return this.$store.getters.getAllRoles
      },

      role: function () {
        return this.$store.getters.getRole
      }

    },


    methods: {



      getAllRoles () {
        this.$loader.loading();
        this.$store.dispatch('getAllRoles')
          .then((response) => {
            this.$loader.close();
          })
          .catch((response) => {
            this.$loader.close();
            this.$message.error({text: response.message});
          })
      },



      deleteRole (id) {
        $('.delete-btn').attr('disabled', true)

        this.$store.dispatch('deleteRole', { id : id })
          .then((response) => {
            this.isLoading = false
            $('.delete-btn').attr('disabled', false)
            $('#deleteConfirm').modal('hide');
          })
          .catch((response) => {
            $('.delete-btn').attr('disabled', false)
            $('#deleteConfirm').modal('hide');
            this.$message.error({text: response.message});
          })

        return true
      },




      setRole (role) {
        this.$store.dispatch('setRole', { role : role })
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/screens/RoleListScreen.vue